export default "__VITE_ASSET__FCXTb4S$__"